import type { TModule } from '@modules/core/types';

import { AUDIT_ENGINE_ROUTE_PATHS } from './config';
import { AUDIT_ENGINE_ROUTES } from './index';

const auditEngineModule: TModule = {
  id: 'audit-engine',
  fallbackRoute: [AUDIT_ENGINE_ROUTE_PATHS.auditEngine],
  permissions: { roles: [] },
  isPublic: false,
  routes: [...AUDIT_ENGINE_ROUTES],
};

export { AUDIT_ENGINE_ROUTE_PATHS as AuditEngineRoutePaths };

export default auditEngineModule;
